type IParser = (url: string) => IParsedUrl;

interface IParsedUrl {
  url?: string;
  success: boolean;
}

function GoogleDriveParser1(url: string): IParsedUrl {
  const match = url?.match(/drive\.google\.com\/file\/d\/(.+?)\//i);
  if (match) {
    return {
      url: `https://drive.google.com/thumbnail?sz=w320&id=${match[1]}`,
      success: true,
    };
  }
  return { success: false };
}

function GoogleDriveParser2(url: string): IParsedUrl {
  const match = url?.match(/drive\.google\.com\/open\?id=([^&]+)/i);
  if (match) {
    return {
      url: `https://drive.google.com/thumbnail?sz=w320&id=${match[1]}`,
      success: true,
    };
  }
  return { success: false };
}

function GlimpseStorageParser(url: string): IParsedUrl {
  let match = url?.match(/glimpse[\da-z]+\.blob\.core\.windows\.net.*jpg/);
  if (match)
    return {
      url: url,
      success: true,
    };
  return { success: false };
}

function GlimpseEuStorageParser(url: string): IParsedUrl {
  let match = url?.match(/videoauditing\.blob\.core\.windows\.net.*jpg/);
  if (match)
    return {
      url: url,
      success: true,
    };
  return { success: false };
}

export function parseImageAttachmentUrl(url: string): IParsedUrl {
  const parsers: IParser[] = [GoogleDriveParser1, GoogleDriveParser2, GlimpseStorageParser, GlimpseEuStorageParser];

  for (const parser of parsers) {
    const result = parser(url);
    if (result.success) {
      return result;
    }
  }

  return {
    success: false,
    url,
  };
}
